
export function cookieBanner(cls = 'cookies-eu-banner') {
    const $cookiesBanner = document.getElementsByClassName(cls).item(0)
    const $cookiesBannerButton = $cookiesBanner?.getElementsByTagName("button").item(0);

    const cookieName = "cookiesBanner";
    const hasCookie = getCookie(cookieName);

    if (!hasCookie)
        $cookiesBanner?.classList.remove("hidden");

    $cookiesBannerButton?.addEventListener("click", () => {
        setCookie(cookieName, "closed")
        $cookiesBanner?.remove()
    })
}

/**
 * @param {string} name
 */
function getCookie(name) {
    const value = " " + document.cookie;
    const parts = value.split(" " + name + "=");
    return parts.length < 2 ? undefined : parts?.pop()?.split(";").shift();
}


/**
 * @param {string} name
 * @param {string} value
 * @param {number} expiryDays
 * @param {string|undefined} domain
 * @param {string} path
 * @param {boolean} secure
 */
function setCookie(name, value, expiryDays=365, domain=undefined, path="/", secure=false) {
    const exdate = new Date();
    exdate.setHours(exdate.getHours() + expiryDays * 24)
    document.cookie =
        `${name}=${value};` +
        `expires=${exdate.toUTCString()};` +
        `path=${path || "/"}` +
        (domain ? `;domain=${domain};` : "") +
        (secure ? ";secure" : "");
}
